(function(){
  var BAR_ID='ea-timer-bar';
  var TIMER_ID='checkout-timer';
  var STORAGE_KEY='ea_cart_timer_expires_at_v1';
  var DURATION_MS = 10*60*1000; // 10 minuten

  function pad(n){return n<10?('0'+n):(''+n);}
  function setTime(sec){
    var el=document.getElementById(TIMER_ID);
    if(!el) return;
    var m=Math.floor(sec/60), s=sec%60;
    el.textContent = pad(m)+':'+pad(s);
  }
  function setExpiry(msFromNow){
    var exp = Date.now() + (msFromNow||DURATION_MS);
    localStorage.setItem(STORAGE_KEY, String(exp));
    setTime(Math.max(0, Math.floor((exp - Date.now())/1000)));
  }
  function clearCartAndNotify(){
    fetch('/cart/clear.js', {method:'POST', headers:{'Content-Type':'application/json'}})
      .finally(function(){
        var b=document.getElementById(BAR_ID);
        if(b){ b.textContent = '⏰ De reservering is verlopen — je winkelwagen is geleegd.'; }
        setTimeout(function(){ location.reload(); }, 800);
      });
  }

  var iv=null;
  function startCountdown(){
    var bar=document.getElementById(BAR_ID);
    if(!bar) return;

    var exp = parseInt(localStorage.getItem(STORAGE_KEY)||'0',10);
    if(!exp || isNaN(exp) || exp < Date.now()){
      setExpiry(DURATION_MS);
      exp = parseInt(localStorage.getItem(STORAGE_KEY),10);
    }

    if(iv) clearInterval(iv);
    function tick(){
      var remaining = Math.floor((exp - Date.now())/1000);
      if(remaining >= 0){ setTime(remaining); }
      if(remaining < 0){
        clearInterval(iv);
        localStorage.removeItem(STORAGE_KEY);
        clearCartAndNotify();
      }
    }
    tick();
    iv = setInterval(tick, 1000);
  }

  // ---- Reset bij Add/Change/Update/Remove ----
  function isCartEndpoint(url){
    return /\/cart\/(add|change|update)(\.js)?/i.test(url);
  }
  function hookResets(){
    // fetch intercept
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input==='string') ? input : (input && input.url) || '';
      var method = (init && (init.method||init.type)) || (typeof input!=='string' && input && input.method) || 'GET';
      return _fetch.apply(this, arguments).then(function(res){
        if (isCartEndpoint(url) && String(method).toUpperCase()==='POST') {
          setExpiry(DURATION_MS);
        }
        return res;
      });
    };

    // XHR intercept (oude scripts)
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__eaMethod = method;
      this.__eaUrl = url || '';
      _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body){
      this.addEventListener('load', () => {
        var ok = (this.status>=200 && this.status<300);
        if (ok && this.__eaMethod && this.__eaUrl &&
            String(this.__eaMethod).toUpperCase()==='POST' &&
            isCartEndpoint(this.__eaUrl)) {
          setExpiry(DURATION_MS);
        }
      });
      _send.apply(this, arguments);
    };

    // Form fallback (non-AJAX)
    document.addEventListener('submit', function(e){
      try{
        var form = e.target;
        if(!form || !form.action) return;
        if (/\/cart\/(add|change|update)(\.js)?/i.test(form.action)) {
          setExpiry(DURATION_MS);
        }
      }catch(_){}
    }, true);

    // Thema events (Prestige e.d.)
    ['product:added','ajaxProduct:added','cart:change','cart:update','lineitem:change']
      .forEach(function(evt){ document.addEventListener(evt, function(){ setExpiry(DURATION_MS); }); });
  }

  // ---- Init ----
  function ensureInit(){
    var bar=document.getElementById(BAR_ID);
    if(bar && !bar.dataset.eaInit){
      bar.dataset.eaInit='1';
      startCountdown();
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    hookResets();
    ensureInit();
  });
  window.addEventListener('load', ensureInit);

  // Observeer DOM (cart drawer wordt dynamisch vervangen)
  var mo = new MutationObserver(ensureInit);
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();
